import React from "react";

interface IntroContentProps {
  content: any;
}

const IntroContent: React.FC<IntroContentProps> = ({ content }) => {
  return (
    <React.Fragment>
      <section className="subscription-intro" dangerouslySetInnerHTML={{ __html: content }} />
    </React.Fragment>
  );
};

export default IntroContent;
